import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const watchesConfig: ServicePageConfig = {
  title: 'Watches - Bespoke Shopping | FGA Prestige',
  description: 'Curating the finest timepieces from prestigious watchmakers worldwide through our bespoke shopping service.',
  slug: 'bespoke-shopping/watches',
  heroImage: '/Bespoke Shopping/Retail Partners/WATCHES/hero.png',
  serviceName: 'WATCHES',
  whySectionA: {
    title: 'Time Well Spent: The Place for Exceptional Watches',
    content: 'When it comes to luxury watches, we believe there\'s something truly special about finding that perfect timepiece. That\'s exactly what we\'re here for. Our boutique isn\'t just another watch shop; we\'re passionate collectors ourselves, and we love helping fellow enthusiasts discover their next great piece.',
    image: '/Bespoke Shopping/Retail Partners/WATCHES/body/1.png',
    imageAlt: 'Watch Expert Assessment'
  },
  whySectionC: {
    title: 'What\'s Happening in the Watch World Right Now',
    content: 'Here\'s the thing – the luxury watch market is absolutely booming, and it\'s not slowing down. A $33.17 billion market that\'s expected to hit $42.39 billion by 2029. But what\'s really interesting is how collecting has evolved. The pre-owned market? It\'s on fire, with 20% annual growth as collectors hunt for those hard-to-find pieces. Smart money knows that certain watches aren\'t just beautiful accessories – they\'re legitimate investments that often outperform traditional assets. We\'ve seen clients pick up pieces that appreciate significantly over time, which honestly makes the whole experience even more satisfying.',
    image: '/Bespoke Shopping/Retail Partners/WATCHES/body/2.png',
    imageAlt: 'Watch Expert Assessment'
  },
  whySectionB: {
    title: '',
    benefits: [
      {
        title: '',
        description: 'Look, buying a luxury watch shouldn\'t feel like a transaction – it should feel like the start of a relationship.'
      },
      {
        title: '',
        description: 'Maybe you\'re after that legendary Omega Speedmaster Professional with actual moon landing history, or perhaps you\'re drawn to a Jaeger-LeCoultre Reverso with custom engraving. Whatever catches your eye, we\'re here to make it happen. Our approach is simple: understand what you love, find the perfect piece, and make sure the whole experience is as smooth as possible.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/WATCHES/body/3.png',
    imageAlt: 'Premium watch collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/WATCHES/CTA_Banner/banner.png'
}

const WatchesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Watches - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Curating the finest timepieces from prestigious watchmakers worldwide through our bespoke shopping service." />
        <meta property="og:title" content="Watches - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Curating the finest timepieces from prestigious watchmakers worldwide through our bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/watches" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/WATCHES/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Luxury Watches" />
      </Helmet>
      
      <ServicePageTemplate config={watchesConfig} />
    </>
  )
}

export default WatchesPage